/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IRingConfiguratorViewProps } from './ring-configurator';
export default (props: IRingConfiguratorViewProps) => {
    return (
        <>
            {props._renderPopUp}
            {props.ringConfiguratorOfflinePopUp}
            <div id={props.config.configuratorDivId}>
                <div className='page-loader'>
                    <div className='loading-spinner' />
                </div>
            </div>
        </>
    );
};
